import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import Logo from '../components/Logo';
import usePageTitle from '../utils/usePageTitle';

const NotFoundContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background-color: var(--color-background);
  position: relative;
  overflow: hidden;
  text-align: center;
`;

const NotFoundCard = styled.div`
  background-color: var(--color-surface);
  border-radius: var(--border-radius-lg);
  padding: 40px;
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.16);
  position: relative;
  z-index: 1;
`;

const NotFoundTitle = styled.h1`
  font-size: 64px;
  font-weight: bold;
  margin: 0;
  color: var(--color-primary);
`;

const NotFoundText = styled.p`
  font-size: 20px;
  color: var(--color-text);
  margin: 16px 0 32px;
`;

const BackgroundGlow = styled.div`
  position: absolute;
  width: 800px;
  height: 800px;
  border-radius: 50%;
  background-color: var(--color-primary);
  filter: blur(250px);
  opacity: 0.07;
  top: -300px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;
`;

export const NotFound: React.FC = () => {
  usePageTitle('Страница не найдена');

  return (
    <NotFoundContainer>
      <BackgroundGlow />

      <NotFoundCard>
        <Logo size="large" />
        <div>
          <NotFoundTitle>404</NotFoundTitle>
          <NotFoundText>Страница не найдена</NotFoundText>
          <Button as={Link} to="/login" variant="primary">
            Вернуться на главную
          </Button>
        </div>
      </NotFoundCard>
    </NotFoundContainer>
  );
};

export default NotFound; 